<template>
  <div class="template-edit">
    <Row :gutter="16">
      <i-col span="14">
        <Form ref="editForm" :model="templateModel"
          :rules="modelValidate"
          label-position="left"
          :label-width="120">
          <FormItem label="名称" prop="name">
            <Input v-model="templateModel.name" placeholder="输入名称" />
          </FormItem>
          <FormItem label="类型" prop="type">
            <Select v-model="templateModel.type" filterable>
              <Option :value="1">HTML</Option>
            </Select>
          </FormItem>
          <FormItem label="应用品种" prop="variety">
            <Select v-model="templateModel.variety" filterable>
              <Option v-for="(tp,idx) in guaTypes" :key="idx" :value="parseInt(tp.id)">{{tp.fullName}}</Option>
            </Select>
          </FormItem>
          <FormItem label="公共模板" v-if="checkRolePermitted(['监管人','总监管人'])">
            <i-switch v-model="templateModel.isPrivate" size="large">
              <span slot="open">私有</span>
              <span slot="close">公共</span>
            </i-switch>
          </FormItem>
          <FormItem label="应用区域" prop="cityId" v-if="templateModel.isPrivate">
            <Cascader :data="cities" :load-data="loadCityData" @on-change="citySelected" placeholder="选择应用的城市区域"></Cascader>
          </FormItem>
          <FormItem label="应用行业/领域" prop="industryId" v-if="templateModel.isPrivate">
            <Select v-model="templateModel.industryId" filterable placeholder="选择应用的行业/领域">
              <Option v-for="item in industries" :value="item.value" :key="item.value">{{ item.label }}</Option>
            </Select>
          </FormItem>
          <FormItem label="内容" prop="template">
          <Input v-model="templateModel.template" type="textarea" :autosize="{minRows: 8,maxRows: 40}" placeholder="请输入模板内容（HTML）"></Input>
          <Button type="text" @click="previewTpl(templateModel)" icon="ios-search">预览</Button>
          <Button type="text" @click="editorView(templateModel)" icon="ios-code-working">在编辑器中编辑</Button>
          <Button type="text" @click="coordSetting(templateModel)" icon="ios-crop">设置印章位置</Button>
        </FormItem>
          <FormItem>
            <Button type="primary" size="large" long @click="submit">保存</Button>
          </FormItem>
        </Form>
      </i-col>
      <i-col span="8">
        <Alert show-icon>
          模板字典
          <template slot="desc">
            <span v-for="(dic,dicIdx) in dictionary" :key="dicIdx">{{dic.value}}:{{dic.key}}<br></span>
          </template>
        </Alert>
      </i-col>
    </Row>
    <!-- <Modal v-model="modalTplPreview" :title="'模板预览 - '+previewTplName" :transfer="false" :styles="{top: '10px'}" width="1024" @on-cancel="previewTplClose">
      <iframe width="100%" height="600" frameborder="0" id="tplPreview"></iframe>
      <div slot="footer">
        <Button type="primary" @click="auditTpl(previewData)" v-if="$store.getters.role==='supervisor'&&previewData.Status===0">审核</Button>
        <Button @click="previewTplClose">取消</Button>
      </div>
    </Modal> -->
    <HtmlEditorModal
      :show="showEditor"
      :content="templateModel.template"
      :dictionary="dictionary"
      @submit="editorSubmit"
      @close-modal="showEditor=false"
    />
    <SealCoordSettingModal
      :show="showCoordSetting"
      :content="templateModel.template"
      @submit="coordSettingSubmit"
      @close-modal="showCoordSetting=false"
    />
    <HtmlPreviewModal
      :show="modalTplPreview"
      :content="previewData"
      @close-modal="previewTplClose"
    />
  </div>
</template>

<script>
import Api from './../../api/Api.js'
import HtmlEditorModal from './../../components/HtmlEditorModal.vue'
import SealCoordSettingModal from './../../components/SealCoordSettingModal.vue'
import HtmlPreviewModal from './../../components/HtmlPreviewerModal.vue'

export default {
  name: 'template-edit',
  components: {
    HtmlEditorModal,
    SealCoordSettingModal,
    HtmlPreviewModal
  },
  props: {
  },
  data () {
    return {
      loading: false,
      templateModel: {
        name: null,
        type: 1,
        isPrivate: true,
        cityId: null,
        guarantorId: null,
        variety: null,
        industryId: null,
        template: null
      },
      modelValidate: {
        name: [
          { required: true, message: '请填写名称', trigger: 'blur' }
        ],
        variety: [
          { required: true, type: 'number', message: '请选择适用品种', trigger: 'blur' }
        ],
        template: [
          { required: true, message: '请填写模板内容', trigger: 'blur' }
        ]
      },
      guaTypes: [],
      cities: [],
      industries: [],
      previewData: {
        name: null,
        type: 1,
        isPrivate: true,
        cityId: null,
        guarantorId: null,
        variety: null,
        industryId: null,
        template: null
      },
      previewTplName: '',
      modalTplPreview: false,
      showEditor: false,
      dictionary: [
        {key: '保函编号', value: '$NUMBER$'},
        {key: '受益人', value: '$BENEFICIARY$'},
        {key: '受益人社会信用代码', value: '$BENEFICIARYLICENSE$'},
        {key: '受益人地址', value: '$BENEFICIARYADDRESS$'},
        {key: '被担保人', value: '$GUARANTEED$'},
        {key: '被担保人社会信用代码', value: '$GUARANTEEDLICENSE$'},
        {key: '被担保人地址', value: '$GUARANTEEDADDRESS$'},
        {key: '起保日期', value: '$STARTDATE$'},
        {key: '终保日期', value: '$ENDDATE$'},
        {key: '施工合同签订日期', value: '$CONTRACTSIGNDATE$'},
        {key: '项目名称', value: '$PROJECT$'},
        {key: '项目编号', value: '$PROJECTNUMBER$'},
        {key: '保证人名称', value: '$GUARANTOR$'},
        {key: '保证人地址', value: '$GUARANTORADDRESS$'},
        {key: '保证人电话', value: '$GUARANTORTEL$'},
        {key: '担保金额（小写）', value: '$amount$'},
        {key: '担保金额（大写）', value: '$AMOUNT$'},
        {key: '担保费率（%）', value: '$RATE$'},
        {key: '保额造价比（%）', value: '$GUARANTEEDRATIO$'},
        {key: '年', value: '$year$'},
        {key: '月', value: '$month$'},
        {key: '日', value: '$day$'}
      ],
      showCoordSetting: false
    }
  },
  watch: {
  },
  mounted () {
    this.templateModel.isPrivate =  !this.checkRolePermitted(['监管人','总监管人'])
    this.getTemplateDetail()
    this.initGuaTypes()
    this.initCitySelect()
    this.initIndustrySelect()
  },
  activated () {
  },
  deactivated () {
  },
  methods: {
    checkRolePermitted (roles) {
      if (!this.$store.getters.userInfo || !this.$store.getters.userInfo.type) {
        return false
      }
      if (this.$store.getters.userInfo.type === 127) {
        return true
      }
      let userRole = this.$common.userType[this.$store.getters.userInfo.type.toString()]
      if (roles instanceof Array) {
        return roles.indexOf(userRole) > -1
      }
      return roles == userRole
    },
    async initGuaTypes () {
      return new Promise((resolve, reject) => {
        this.$Spin.show()
        this.$Api.Guarantee.getGuaranteeVarieties().then(res => {
          this.guaTypes = res
          this.$Spin.hide()
          resolve(res)
        }).catch(err => {
          this.$Message.error(err.message)
          this.$Spin.hide()
          reject(err)
        })
      })
    },
    getTemplateDetail () {
      Api.GuaranteeTemplate.getGuaranteeTemplateDetail(this.$route.params.templateId).then((res) => {
        Object.assign(this.templateModel, res)
        // document.getElementById('tplPreview').contentWindow.document.write(this.templateModel.template)
        // document.getElementById('tplPreview').contentWindow.document.close()
      }).catch(err => {
        this.$Message.error('获取详情失败!' + err.message)
      })
    },
    editorSubmit (html) {
      let htmlHead = `<html lang="zh-cn" xmlns="http://www.w3.org/1999/xhtml"><head>
            <meta charset="utf-8">
            <meta http-equiv="X-UA-Compatible" content="IE=edge">
            <title>${this.templateModel.name}-模板</title>
            <meta content="width=device-width, initial-scale=1, maximum-scale=1, user-scalable=no" name="viewport">

            <style>
                .container {
                    margin: 0 auto;
                    width: 95%;
                    position: relative;
                }
            </style>
        </head>
        <body>
            <div class="container">`
      let htmlEnd = `
            </div>
        </body></html>`
      this.templateModel.template = htmlHead + html + htmlEnd
    },
    coordSetting (tpl) {
      console.log(tpl)
      this.showCoordSetting = true
    },
    coordSettingSubmit (pageIndex, sealX, sealY, sealWidth, sealHeight) {
      console.log(pageIndex, sealX, sealY, sealWidth, sealHeight)
    },
    editorView (tpl) {
      console.log(tpl)
      this.showEditor = true
    },
    previewTpl (tpl) {
      this.previewData = {
        name: null,
        type: 1,
        isPrivate: true,
        cityId: null,
        guarantorId: null,
        variety: null,
        industryId: null,
        template: null
      }
      if (tpl) {
        // this.previewData = tpl
        this.previewData = tpl.template
        // document.getElementById('tplPreview').contentWindow.document.write(this.previewData.template)
        // document.getElementById('tplPreview').contentWindow.document.close()
        this.modalTplPreview = true
        this.previewTplName = tpl.name
      }
    },
    previewTplClose () {
      this.previewData = {
        name: null,
        type: 1,
        isPrivate: true,
        cityId: null,
        guarantorId: null,
        variety: null,
        industryId: null,
        template: null
      }
      this.modalTplPreview = false
    },
    initIndustrySelect () {
      Api.Industry.listIndustries({
      }, 1, 1000).then((res) => {
        let data = res.data.map((c) => {
          return {
            id: c.id,
            value: c.id,
            label: c.name
          }
        })
        this.industries = data
      }).catch(err => {
        this.$Message.error('获取行业列表失败!' + err.message)
      })
    },
    initCitySelect () {
      Api.City.listCities({
        tier: 1,
        isVisible: null
      }, 1, 1000).then((cities) => {
        let data = cities.data.map((c) => {
          return {
            id: c.tid,
            value: c.tid,
            label: c.name,
            tier: c.tier,
            parent: c.parent,
            loading: false,
            children: []
          }
        })
        this.cities = data
      }).catch(err => {
        this.$Message.error('获取城市列表失败!' + err.message)
      })
    },
    loadCityData (item, callback) {
      item.loading = true
      let parentId = item.value
      let tier = item.tier || 0
      let curNode = null
      if (tier === 1) {
        curNode = this.cities.filter((c) => {
          return c.id === item.id
        })[0]
      } else {
        let parentNode = this.cities.filter((c) => {
          return c.id === item.parent
        })
        curNode = parentNode[0]
      }
      console.log(curNode)
      Api.City.listCities({
        tier: tier + 1,
        parentId: parentId,
        isVisible: null
      }, 1, 1000).then((cities) => {
        let data = cities.data.map((c) => {
          if (tier === 1) {
            return {
              id: c.tid,
              value: c.tid,
              label: c.name,
              tier: c.tier,
              parent: c.parent,
              loading: false,
              children: []
            }
          } else {
            return {
              value: c.tid,
              label: c.name,
              tier: c.tier,
              parent: c.parent
            }
          }
        })
        let retData = [{
          value: parentId,
          label: '本级'
        }]
        data.forEach((d) => {
          retData.push(d)
        })
        if (tier === 0) {
          curNode = retData
        } else {
          item.children = retData
        }
        item.loading = false
        callback()
      }).catch(err => {
        this.$Message.error('获取城市列表失败!' + err.message)
        item.loading = false
        callback()
      })
    },
    citySelected (val) {
      if (val instanceof Array) {
        this.templateModel.cityId = val[val.length - 1]
      } else {
        this.templateModel.cityId = val
      }
    },
    async submit () {
      this.$refs.editForm.validate(async (valid) => {
        if (valid) {
          this.loading = true
          this.$Spin.show()
          await Api.GuaranteeTemplate.updateGuaranteeTemplate(this.templateModel)
            .then((payload) => {
              console.log('suc', payload)
              this.$Message.success('修改成功!')
              this.loading = false
              this.$Spin.hide()
            })
            .catch(err => {
              console.log('err', err)
              this.$Message.error('提交失败!' + err.message)
              this.loading = false
              this.$Spin.hide()
            })
        }
      })
    }
  }
}
</script>

<style lang="less">
</style>
